module.exports = __webpack_public_path__ + "static/media/DSC09999.9d85b20b.jpg";